/**
 * Build a login username from a person's full name.
 * "John Doe" → "john.doe", "Mary Jane Watson" → "mary.watson"
 */
export function generateUsernameFromName(fullName: string): string {
  const parts = String(fullName || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s.-]/g, '')
    .trim()
    .split(/[\s.]+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return 'demo.user';
  }
  if (parts.length === 1) {
    return parts[0];
  }
  return `${parts[0]}.${parts[parts.length - 1]}`;
}
